export default __webpack_public_path__ + "static/media/selected-facility-legend-icon-new.c727e0bd.svg";